import { ReactElement } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import CustomFormControl from './CustomFormControl';
import CustomHelperText from './CustomHelperText';
import FormLabel from '@mui/material/FormLabel';
import { BEM_NAME_ELEMENTS } from 'pages/NewNonEmployee/_const';

/**
 * customized field for a set of radio buttons
 * @param {string|ReactElement} label label to display
 * @param {object[]} options choices to display in the form of {label, value}
 * @param {boolean} required if required, display an indicator
 * @param {string|ReactElement} helperText default on-screen assistance
 * @param {any} props properties to be passed to the checkbox
 * @returns {ReactElement} radio button group
 */
const CustomRadioGroup = ({
	id,
	label,
	options = [],
	required,
	helperText,
	...props
}) => {
	const [field, meta] = useField(props);

	return (
		<CustomFormControl error={meta.touched && !!meta.error}>
			<FormLabel id={'radio-group-' + id}>{label}</FormLabel>
			<RadioGroup
				aria-labelledby={'radio-group-' + id}
				{...props}
				{...field}
			>
				{options.map(option => (
					<FormControlLabel
						key={option.key ?? option.value}
						value={option.value}
						control={
							<Radio
								id={`${BEM_NAME_ELEMENTS.VIEW_FORM}____${BEM_NAME_ELEMENTS.FIELD_RADIOS}--${props.name}-${option.label}`}
							/>
						}
						label={option.label}
					/>
				))}
			</RadioGroup>
			<CustomHelperText
				error={meta.error}
				touched={meta.touched}
				helperText={helperText}
			/>
		</CustomFormControl>
	);
};

CustomRadioGroup.propTypes = {
	label: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any.isRequired,
			label: PropTypes.string.isRequired,
		})
	).isRequired,
	required: PropTypes.bool,
	helperText: PropTypes.string,
	name: PropTypes.string.isRequired,
};

export default CustomRadioGroup;
